import CheckboxListFieldComponent from './checkbox-list-field-component';

/***
 * A field that renders a list of checkbox options. It expects to be passed in a list of options, as well as the number
 * of columns to render the options in.
 */
const checkboxListField = angular
    .module('FacilityData.ClientEdit.FormFields.CheckboxListField', [])
    .component('checkboxListField', CheckboxListFieldComponent)
    .name;

export default checkboxListField;


// WEBPACK FOOTER //
// ./app/common/form-fields/checkbox-list-field/checkbox-list-field.js